import { render, staticRenderFns } from "./FeedPreviewItem.vue?vue&type=template&id=2964dd10&"
import script from "./FeedPreviewItem.vue?vue&type=script&lang=js&"
export * from "./FeedPreviewItem.vue?vue&type=script&lang=js&"
import style0 from "./FeedPreviewItem.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports